import { render, staticRenderFns } from "./diaLog.vue?vue&type=template&id=3f960d58&"
import script from "./diaLog.vue?vue&type=script&lang=js&"
export * from "./diaLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports